import React, { useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { download, Search_icon } from "../../assets/img";
import DateRange from "../../components/DateRange/DateRange";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation } from "react-router-dom";
import { Table } from "../../components/Table/Table";
import moment from "moment";

const DailyLogReport = () => {
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const [count, setCount] = useState(0);
  const { paginationData, setpaginationData } = useGlobalContext();
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [search, setSearch] = useState(paginationData?.[path]?.search ?? "");
  const [pagination, setPagination] = useState({});
  const [list, setList] = useState([]);

  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
  });

  const handleChangeFilter = (name, val) => {
    let { from, to } = selectedFilter;
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "Date",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD/MM/YYYY")}</p>;
        },
      },
      {
        Header: "Log File",
        accessor: "email",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "File Size(KB)",
        accessor: "mobile",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Permission",
        accessor: "city_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-js gap-3">
                <button className="cust-btn ">
                  <img src={download} alt="" className=" edit-btn " />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page],
  );

  return (
    <div>
      <Topbar header={"Daily Log"} subHead={"Report"} />
      <div>
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 mb-4">
          Total:{count}
        </h2>
        <div className="d-flex ac-jb gap-3">
          <DateRange
            setFromDate={(date) => {
              handleChangeFilter("from", date);
            }}
            setToDate={(date) => {
              handleChangeFilter("to", date);
            }}
          />
          <div className="search-input">
            <input
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
              onChange={(e) => {
                setPage(1);
                setSearch(e.target.value);
              }}
              value={search}
            />
            <img alt="" src={Search_icon} className="search" />
          </div>
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={true}
      />
    </div>
  );
};

export default DailyLogReport;
